<template>
    <section class="tables landing-page">
        <div class="email-template">
            <div class="template-head">
                <img src="https://dctrainings.com/gts/images/newsletter/logo.png?v=1" alt="logo">
            </div>
            <div class="inner-body">
                <div class="template-inner" >
                    <h1>{{ contentResData.Subject }}</h1>
                    
                    <h2>{{ contentResData.Salutation }}</h2>

                    <div v-html="contentResData.TextBox1">

                    </div>
                    <div v-html="contentResData.TextBox2">

                    </div>
                </div>
                <div class="template-footer">
                    <p>Copyright 2011 - 2023 | DC Trainings, Inc. All Rights Reserved.</p>
                </div>
            </div>
        </div>

    </section>
</template>
<script>

import Vue from "vue";
import API from '@/api';
import CKEditor from 'ckeditor4-vue';
Vue.use(CKEditor);
// Vue.use(VueTimepicker);

export default {
    name: 'view_email_template',
    data() {
        return {
            setScheduler: false,
            id: "",

            userSecShow: false,
            multiUserDropdown: {
                options: [],
                isLoading: false,
                searchTerm: "",
                userDataList: []
            },
            contentResData: {
                ContentType: "Email",
                GroupID: "",
                options: [],
                userDataList: [],
                number_of_users: 0,
                selected_users_d: [],
                is_draft: true,
                IsEM: true,
                TextBox1: " ",
                TextBox2: `
                
                `,
                Subject: "",
                Salutation: "",
                Interval: 'daily',
                SendTime: "12:00 pm",
                SchedulerStatus: 'update',
                StopDate: "",
                StartDate: ''
            },
        }
    },
    methods: {
        getDraftEmailById() {
            this.contentResData = this.$route.params.data;
            console.log(this.contentResData);
        },
    },
    mounted() {
        this.getDraftEmailById()
    },
}

</script>
<style>
    .email-template {
        text-align: center;
        max-width: 840px;
        margin: 0 auto;
        background: rgb(240, 240, 240);
        font-family: Verdana,Arial !important;
        font-size: 14px;
        line-height: 20px;
        padding-bottom: 50px;
    }
    .template-head {
        background: rgb(20, 55, 120);
        padding: 20px 0 60px;
    }
    .template-inner {
        background: #fff;
        margin: -45px 40px 0;
        border-radius: 10px 10px 0 0;
        padding: 120px 0 30px 0;
    }
    .template-footer {
        border-top: 1px solid rgb(235, 235, 235);
        background: rgb(20, 55, 120);
        color: #aac8fe;
        font-size: 11px;
        height: 45px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 40px;
        border-radius: 0 0 10px 10px;
    }
    .template-footer p {
        margin: 0;
    }
</style>